<template>
    <div class="row">
        <div class="col-md-12 np-progress">
            <span>{{label}}</span>
            <span class="np-progress__status">{{state}}</span>
<!--            <div class="progress">-->
<!--                <div-->
<!--                        aria-valuemax="100"-->
<!--                        aria-valuemin="0"-->
<!--                        :aria-valuenow="`${currentStatusConfig.progress_width}`"-->
<!--                        :style="`width:${currentStatusConfig.progress_width}%`"-->
<!--                        :class="[{'progress-bar-striped': striped, 'active': animated}, currentStatusConfig.progress_class, 'progress-bar']"-->
<!--                >-->
<!--                    <span class="progress-text addTooltip" :data-tooltip-text="tooltipText"></span>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script>
    export default {
        name: "np-progress",
        props: {
            train_tracks: {},
            animated: {
                type: Boolean,
                default: false
            },
            striped: {
                type: Boolean,
                default: false
            },
            statusConfig: {},
            state: {
                type: String
            },
            mode: {
                type: String
            },
            label: {
                type: String,
            }
        },
        data: function () {
            return {
                defaultStatusConfig: {
                    success: {
                        progress_class: 'progress-bar-success',
                        progress_width: '100',
                    },
                    info: {
                        progress_class: 'progress-bar-info',
                        progress_width: '50',
                    },
                    failed: {
                        progress_class: 'progress-bar-failed',
                        progress_width: '50',
                    },
                    warning : {
                        progress_class: 'progress-bar-warning ',
                        progress_width: '50'
                    }
                }
            }
        },
        created: function(){
        },
        mounted: function() {
            // Overwrite status default status config if required
            let statusKeys = !!this.statusConfig ? Object.keys(this.statusConfig) : [];
            if (Object.keys(statusKeys).length > 0) {
                for(var statusKey in statusKeys) {
                    if (this.defaultStatusConfig.hasOwnProperty(statusKey)) {
                        this.defaultStatusConfig[statusKey] = this.statusConfig[statusKey];
                    }
                }
            }
        },
        methods: {

        },
        computed: {
            currentStatusConfig() {
                if (this.defaultStatusConfig.hasOwnProperty(this.mode)) {
                    return this.defaultStatusConfig[this.mode];
                }
                return this.defaultStatusConfig['warning'];
            },
            tooltipText() {
                return `${this.label} - ${this.state}`
            }
        },
        watch: {

        }
    }
</script>

<style scoped>
.np-progress .progress {
    height: 3px;
}

.np-progress .np-progress__status {
    float: right;
}

</style>